/* ============================================================
   LANDR — global interactions
   (vanilla JS, no dependencies)
   ============================================================ */
(function () {
  "use strict";

  const root = document.documentElement;

  /* ---- generic toggle: [data-toggle="#target"] ---- */
  function setOpen(target, open) {
    if (!target) return;
    target.toggleAttribute("data-open", open);
    target.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.classList.toggle("no-scroll", open && target.hasAttribute("data-lock-scroll"));
  }

  document.addEventListener("click", function (e) {
    const opener = e.target.closest("[data-toggle]");
    if (opener) {
      const target = document.querySelector(opener.getAttribute("data-toggle"));
      const willOpen = !(target && target.hasAttribute("data-open"));
      setOpen(target, willOpen);
      opener.setAttribute("aria-expanded", String(willOpen));
      return;
    }
    const closer = e.target.closest("[data-close]");
    if (closer) {
      const panel = closer.closest("[data-open]") || document.querySelector(closer.getAttribute("data-close"));
      setOpen(panel, false);
      return;
    }
    // click on overlay
    if (e.target.matches("[data-overlay]")) {
      setOpen(e.target.closest("[data-open]") || e.target.parentElement, false);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll("[data-open]").forEach((el) => setOpen(el, false));
    }
  });

  /* ---- cart: add to cart via fetch, open drawer ---- */
  async function refreshCartDrawer() {
    try {
      const res = await fetch("/?section_id=cart-drawer");
      if (!res.ok) return;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      const fresh = doc.querySelector("#cart-drawer .cart-drawer__inner");
      const current = document.querySelector("#cart-drawer .cart-drawer__inner");
      if (fresh && current) current.replaceWith(fresh);
      updateCartCount();
    } catch (err) { /* noop */ }
  }

  async function updateCartCount() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.toggleAttribute("data-has-items", cart.item_count > 0);
      });
    } catch (err) { /* noop */ }
  }

  document.addEventListener("submit", async function (e) {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : "";
    if (btn) { btn.setAttribute("disabled", ""); btn.dataset.loading = "true"; }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(new FormData(form)),
      });
      if (res.ok) {
        await refreshCartDrawer();
        const drawer = document.querySelector("#cart-drawer");
        setOpen(drawer, true);
      }
    } finally {
      if (btn) { btn.removeAttribute("disabled"); btn.dataset.loading = "false"; btn.innerHTML = original; }
    }
  });

  /* ---- cart line quantity / remove (drawer + cart page) ---- */
  async function changeLine(line, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
    return res.json();
  }

  document.addEventListener("click", async function (e) {
    const qtyBtn = e.target.closest("[data-qty-change]");
    if (qtyBtn) {
      const wrap = qtyBtn.closest("[data-line]");
      const input = wrap ? wrap.querySelector("[data-qty-input]") : qtyBtn.parentElement.querySelector("input");
      if (!input) return;
      const dir = parseInt(qtyBtn.getAttribute("data-qty-change"), 10);
      let val = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
      input.value = val;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  document.addEventListener("change", async function (e) {
    const input = e.target.closest("[data-qty-input]");
    if (!input) return;
    const wrap = input.closest("[data-line]");
    if (!wrap) return;
    const line = parseInt(wrap.getAttribute("data-line"), 10);
    const cart = await changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
    if (wrap.closest("#cart-drawer")) refreshCartDrawer();
    else window.location.reload();
    void cart;
  });

  // initialise count on load
  document.addEventListener("DOMContentLoaded", updateCartCount);
  void root;
})();
